import Requests from "@/services/Requests";

const state = {
  paymentMethods: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  allPaymentMethods: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed", // unitiliazed, loading, success, error
  updateStatus: "unitiliazed", // unitiliazed, loading, success, error
  deleteStatus: "unitiliazed", // unitiliazed, loading, success, error
  paymentMethodById: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
};
const getters = {
  /**
   * Returns a subset of paymentMethods based on the given page number.
   *
   * @param {Object} state - The Vuex state object.
   * @param {number} [page=0] - The page number to filter paymentMethods by. Defaults to 0.
   * @return {Array} An array of paymentMethods filtered by the given page number. If page is 0, returns all paymentMethods.
   */
  getPaymentMethods:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.paymentMethods.data
        : state.paymentMethods.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getAllPaymentMethods: (state) => state.allPaymentMethods.data,
  getPaymentMethodStatus: (state) => state.paymentMethods.status,
  getPaymentMethodCount: (state) => state.paymentMethods.count,
  getPaymentMethodPage: (state) => state.paymentMethods.page,
  getPaymentMethodsLoading: (state) =>
    state.paymentMethods.status === "loading",
  getPaymentMethodById: (state) => (id) =>
    state.paymentMethodById.data.find((d) => d.id === id) || {},
};
const mutations = {
  /**
   * Updates the status of the paymentMethod in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the paymentMethod.
   */
  SET_PAYMENT_METHOD_STATUS(state, payload) {
    console.log(state.paymentMethods, "status: ", payload);
    state.paymentMethods.status = payload;
  },
  /**
   * Sets the paymentMethods and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of paymentMethods.
   * @param {number} payload.count - The total count of paymentMethods.
   */
  SET_PAYMENT_METHODS(state, payload) {
    state.paymentMethods.data = payload.items;
    state.paymentMethods.count = payload.count;
  },
  /**
   * Sets the paymentMethods and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of paymentMethods.
   * @param {number} payload.count - The total count of paymentMethods.
   */
  SET_ALL_PAYMENT_METHODS(state, payload) {
    console.log("SET_ALL_PAYMENT_METHODS", payload);
    state.allPaymentMethods.data = payload.items;
    state.allPaymentMethods.count = payload.count;
  },
  /**
   * Updates the status of the update paymentMethod in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the paymentMethod.
   */
  SET_UPDATE_PAYMENT_METHOD_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  /**
   * Updates an paymentMethod object in the state with new information.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The updated paymentMethod object.
   * @return {void}
   */
  SET_UPDATE_PAYMENT_METHOD(state, payload) {
    const index = state.paymentMethods.data.findIndex(
      (d) => d.id === payload.id
    );
    const paymentMethod = state.paymentMethods.data[index];
    state.paymentMethods.data[index] = { ...paymentMethod, ...payload };
  },
  SET_CREATE_PAYMENT_METHOD_STATUS(state, payload) {
    state.createStatus = payload;
  },
  /**
   * Adds a new paymentMethod to the list of paymentMethods in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The paymentMethod object to be added.
   * @return {void}
   */
  SET_CREATE_PAYMENT_METHOD(state, payload) {
    state.paymentMethods.data.push(payload);
  },
  /**
   * Updates the status of the delete paymentMethod in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the paymentMethod.
   */
  SET_DELETE_PAYMENT_METHOD_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  /**
   * Removes an paymentMethod from the state based on the provided payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the paymentMethod ID to be deleted.
   * @param {number} payload.id - The ID of the paymentMethod to be deleted.
   * @return {void}
   */
  SET_DELETE_PAYMENT_METHOD(state, payload) {
    state.paymentMethods.data = state.paymentMethods.data.filter(
      (d) => d.id !== payload.id
    );
  },
  SET_PAYMENT_METHOD_BY_ID_STATUS(state, payload) {
    state.paymentMethodById.status = payload;
  },
  SET_PAYMENT_METHOD_BY_ID(state, payload) {
    state.paymentMethodById.data.push(payload);
  },
};

const actions = {
  /**
   * Retrieves a list of paymentMethods based on the provided payload.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the query parameters.
   * @param {Object} payload.query - The query parameters.
   * @param {string} payload.query.searchKey - The search key.
   * @param {string} payload.query.regionId - The region ID.
   * @param {string} payload.query.companyId - The company ID.
   * @param {number} payload.query.page - The page number.
   * @return {Promise<void>}
   */
  async getPaymentMethods({ commit, state }, payload) {
    const status = state.paymentMethods.status;
    commit("SET_PAYMENT_METHOD_STATUS", "loading");
    const response = await Requests.PaymentMethod.GetAll(payload);
    if (response.message === "OK") {
      commit("SET_PAYMENT_METHODS", {
        items: response.data.map((item) => ({
          ...item,
          page: payload.query.page || 1,
        })),
        count: response.data.length,
      });
      console.log(payload, "payload", payload.initial, "inital");
      if (status === "unitiliazed")
        commit("SET_ALL_PAYMENT_METHODS", {
          items: response.data.map((item) => ({
            ...item,
            page: payload.query.page || 1,
          })),
          count: response.data.length,
        });
    }
    commit("SET_PAYMENT_METHOD_STATUS", "success");
    return response.message;
  },
  /**
   * Creates an paymentMethod by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the paymentMethod data.
   * @param {string} payload.paymentMethod - The paymentMethod data.
   * @param {string} payload.payType - The payment type.
   * @return {Promise<void>} - A promise that resolves when the creation is complete.
   */
  async createPaymentMethod({ state, commit }, payload) {
    state.createStatus = "loading";
    try {
      const response = await Requests.PaymentMethod.Create(payload);
      state.createStatus = "success";
      if (response.message === "OK")
        commit("SET_CREATE_PAYMENT_METHOD", {
          id: response.data,
          ...payload,
          isActive: true,
          page: 1,
        });
      else state.createStatus = "error";
    } catch {
      state.createStatus = "error";
    }
  },
  /**
   * Updates an paymentMethod by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the paymentMethod data.
   * @param {number} payload.id - The ID of the paymentMethod to be updated.
   *  @param {string} payload.paymentMethod - The paymentMethod data.
   * @param {string} payload.payType - The payment type.
   * @param {string} payload.isActive - The paymentMethod status.
   * @return {Promise<void>} - A promise that resolves when the update is complete.
   *
   */
  async updatePaymentMethod({ state, commit }, payload) {
    state.updateStatus = "loading";
    try {
      const response = await Requests.PaymentMethod.Update(payload, {
        params: { id: payload.id },
      });
      if (response.message === "OK") {
        commit("SET_UPDATE_PAYMENT_METHOD", payload);
        state.updateStatus = "success";
      } else {
        state.updateStatus = "error";
      }
      return true;
    } catch {
      state.updateStatus = "error";
    }
  },
  /**
   * Removes an paymentMethod from the state and updates the delete status.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the paymentMethod data.
   * @param {number} payload.id - The ID of the paymentMethod to be removed.
   * @returns {Promise<void>} A promise that resolves when the paymentMethod is successfully removed.
   */
  removePaymentMethod({ state }, { id }) {
    state.deleteStatus = "loading";

    return Requests.PaymentMethod.Delete({ id })
      .then((response) => {
        state.deleteStatus = response.message === "OK" ? "success" : "error";
      })
      .catch(() => {
        state.deleteStatus = "error";
      });
  },
  /**
   * Retrieves an paymentMethod by their ID and updates the paymentMethod by ID status in the Vuex store.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} id - The ID of the paymentMethod to retrieve.
   * @return {Promise} A promise that resolves when the paymentMethod is successfully retrieved and the status is updated.
   */
  getPaymentMethodById({ commit, state }, { id }) {
    // check if paymentMethod already exists in the state;
    if (
      state.paymentMethodById.data.find(
        (paymentMethod) => paymentMethod.id === id
      )
    )
      return;
    commit("SET_PAYMENT_METHOD_BY_ID_STATUS", "loading");
    return Requests.PaymentMethod.GetById({ params: { id } })
      .then((response) => {
        commit("SET_PAYMENT_METHOD_BY_ID", response.data);
        commit("SET_PAYMENT_METHOD_BY_ID_STATUS", "success");
      })
      .catch(() => {
        commit("SET_PAYMENT_METHOD_BY_ID_STATUS", "error");
      });
  },
};

export default { state, getters, mutations, actions };
